/**
 * Base api path
 *
 * @type {string}
 */

// export const apiPath = 'https://cdn-api.valet';
// export const clientSecret = 'pguJuhWDnFmVn9fzZRrkxl2hKCNmSKXKWUoyvg4N';

export const debugMode = true;
//
export const apiPath = "https://api.cdn.livestormsvideo.com";
export const clientSecret = "pguJuhWDnFmVn9fzZRrkxl2hKCNmSKXKWUoyvg4N";

export const sitePath = "https://cdn.livestormsvideo.com/";
